/* eslint-disable max-statements */
/* eslint-disable max-lines-per-function */
import { useKeystoneSession } from '../../../auth/use-keystone-session';
import { useAppDispatch } from '@state';
import { Flex, Stack, Text, useColorModeValue, VStack } from '@chakra-ui/react';

import { Note, NoteType } from '@rta/rta-blueprint-library';
import { useDesign } from '@hooks';


type CommentItemProps = {
	data: Note;
}

export const CommentItem = (props: CommentItemProps) => {
	const {
		data
		// onChangeQuantity,
		// onClickDelete,
	} = props;

	const { user } = useKeystoneSession();

	const [controller] = useDesign();

	const currentUser = user?.email;

	let userColor = 'gray.500';
	let userSide = 'start';
	if (data.createdBy === currentUser) {
		userColor = 'blue.300';
		userSide = 'end';
	}

	const isAnnotation = data.type === NoteType.Annotation && !!data.artifactId;

	const handleClick = () => {
		if (isAnnotation && controller) {
			controller.publish('sku-annotation-select', 'select', { annotationId: data.artifactId });
		}
	};

	const dispatch = useAppDispatch();

	return (
		<Stack overflow="hidden" width="full" spacing="0" mb="5px" pr="5px">
			{/* <Image
					rounded="md"
					minWidth="10"
					maxWidth="10"
					height={{ base: '10', md: '10' }}
					fit="cover"
					// src={imageUrl}
					// alt={name}
					draggable="false"
					loading="lazy"
				/> */}
			<VStack spacing="0.1" width="full" align={userSide}>
				<Text
					fontSize="10px"
				>
					{`${data.createdBy} - ${data.createDate.toLocaleString(undefined, { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: '2-digit' })}`}
				</Text>
				<Flex pl="5px" bg={userColor} width="75%" roundedRight={'6px'} roundedLeft={'6px'}
					cursor={isAnnotation ? 'pointer' : 'default'}
					onClick={handleClick}
					_hover={isAnnotation ? { opacity: 0.85 } : undefined}
				>

					<Text
						color={useColorModeValue('white', 'white')}
						fontSize="sm"
						wordBreak="break-word"
					>
						{data.message}
					</Text>

					{/* { showDescriptionInput &&
						<InputGroup pl="5px" pb="5px">
							<InputLeftElement pointerEvents="none">
								<Text fontSize="sm">Description:</Text>
							</InputLeftElement>
							<Input
								type="text"
								value={inputDescription}
								onChange={(e) => setInputDescription(e.target.value)}
								onBlur={() => {
									setShowDescriptionInput(false);
									// Exactly match price pattern: dispatch action and set trigger state
									dispatch(setPromotionalDescription([sku, inputDescription]));
									setDescriptionToChange(sku);
								}}
								onKeyPress={(e) => {
									if (e.key === 'Enter') {
										setShowDescriptionInput(false);
										dispatch(setPromotionalDescription([sku, inputDescription]));
										setDescriptionToChange(sku);
									}
								}}
								autoFocus
							/>
						</InputGroup>
					} */}
				</Flex>
				{/* <Flex justifyContent="space-between">

					{
						<RtaIconButton enabled={ true } tabIndex={-1} height={'1.25em'} color={'red.500'} icon={removePromotionalSku.icon()} onClick={() => {
							dispatch(setRemovedPromotionalSku(sku));
							setDeleteSku(sku);
						} }/>
					}
				</Flex> */}
			</VStack>
		</Stack>
	);
};
